module.exports = __webpack_public_path__ + "img/Carousel1.0ee3b3a4.png";